module.exports = __webpack_public_path__ + "static/media/odonnelloneill.e496c846.jpg";